import { createFileRoute } from "@tanstack/react-router";
import LaBlueInsurance, { config } from "@/pages/LaBlueInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/la-blue-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Louisiana Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Louisiana Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Louisiana Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Louisiana Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/la-blue-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/la-blue-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <LaBlueInsurance />;
}
